import { OrderedMap, Seq } from 'immutable';
import { RestAPI } from '@/util/net.js';
import { putError } from '@/store/error.store';
import { markStoreLoading, markStoreLoaded } from '@/store/storeForStoringStatusOfStores.store';

/* eslint-disable */
function fromJSOrdered(js) {
  return typeof js !== 'object' || js === null ? js :
    Array.isArray(js) ?
      Seq(js).map(fromJSOrdered).toList() :
      Seq(js).map(fromJSOrdered).toOrderedMap();
}
/* eslint-enable */

export const earningStatementsReportReducer = (state = new OrderedMap(), action) => {
  switch (action.type) {
    case 'EARNING_STATEMENTS_REPORT_LOADED':
      return fromJSOrdered(action.data);
    case 'EARNING_STATEMENTS_REPORT_CLEAR':
      return new Map();
    default:
      return state;
  }
};

export const generateReport = (dispatch, from, to) => {
  dispatch({ type: 'LOADING_EARNING_STATEMENTS_REPORT' });
  markStoreLoading(dispatch, 'earningStatement');
  return RestAPI.get(`/api/report/earningStatements?dateFrom=${from ? from.toJSON()
    .split('T')[0] : ''}&dateTo=${to ? to.toJSON().split('T')[0] : ''}`)
    .then(
      data => {
        markStoreLoaded(dispatch, 'earningStatement');
        dispatch({ type: 'EARNING_STATEMENTS_REPORT_LOADED', data });
      }
    ).catch(
      (data) => {
        putError(dispatch, data);
        markStoreLoaded(dispatch, 'earningStatement');
        dispatch({ type: 'EARNING_STATEMENTS_REPORT_LOADING_FAILED' });
      }
    );
};

export const clearReport = (dispatch) => dispatch({ type: 'EARNING_STATEMENTS_REPORT_CLEAR' });
